var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrh9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.812,
    height: 69.333,
    viewBox: "0 0 49.812 69.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 52h37.359V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.3333 0 0 -1.3333 0 69.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.979 24.669v-8.656H7.353v8.656H0V.002h7.353v8.656h2.626V.002h7.354v24.667zM7.353 39.427v5.261a2.627 2.627 0 002.63-2.632 2.629 2.629 0 00-2.63-2.629m0 12.573H0V27.333h7.353v4.786c5.524 0 10.001 4.454 10.001 9.937 0 5.49-4.477 9.944-10.001 9.944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b34e",
    d: "M27.373 14.731a2.629 2.629 0 002.631 2.628V12.1a2.634 2.634 0 00-2.631 2.631m-7.369 0c0-5.49 4.476-9.937 10-9.937V.002h7.353v24.667h-7.353c-5.524 0-10-4.448-10-9.938"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.35 44.688a2.626 2.626 0 002.627-2.632 2.628 2.628 0 00-2.627-2.629zm9.998-2.632c0 5.49-4.477 9.944-9.998 9.944h-7.355V27.333h7.355v4.608l4.607-4.608h5.391v4.943l-2.846 2.845a9.854 9.854 0 012.846 6.935"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrh9);
export default __webpack_public_path__ + "static/media/prh9.8f8de87f935b96edb3ee2e359599076f.svg";
export { ForwardRef as ReactComponent };